/**
 * ObstacleRegistry - tracks decoration obstacles (trees, rocks, etc.)
 * Used by pathfinding to avoid these obstacles
 */

export class ObstacleRegistry {
  // Set of occupied tile keys: "tileX,tileZ"
  private obstacles: Set<string> = new Set();

  /**
   * Register an obstacle at world position
   */
  registerObstacle(worldX: number, worldZ: number): void {
    const tileX = Math.floor(worldX);
    const tileZ = Math.floor(worldZ);
    const key = `${tileX},${tileZ}`;
    this.obstacles.add(key);
  }

  /**
   * Check if a tile has an obstacle
   */
  hasObstacle(tileX: number, tileZ: number): boolean {
    const key = `${tileX},${tileZ}`;
    return this.obstacles.has(key);
  }

  /**
   * Remove an obstacle
   */
  removeObstacle(worldX: number, worldZ: number): void {
    const tileX = Math.floor(worldX);
    const tileZ = Math.floor(worldZ);
    const key = `${tileX},${tileZ}`;
    this.obstacles.delete(key);
  }

  /**
   * Clear all obstacles
   */
  clear(): void {
    this.obstacles.clear();
  }

  /**
   * Get count of registered obstacles
   */
  getCount(): number {
    return this.obstacles.size;
  }
}

// Singleton instance
export const obstacleRegistry = new ObstacleRegistry();
